module.exports = __webpack_public_path__ + "static/media/highlightNotification.8aa57619.svg";